/**
 * Acl entity class
 */

import { ACL_MODE_TYPES } from 'app/core/constants'

/**
 * AclFactory
 * returns Acl entity class
 *
 * @class AclFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Acl} class
 *
 * @ngdoc factory
 * @name mwApp.factory:AclFactory
 */
/* @ngInject */
export default function AclFactory ($http, Entity, onOffMixin, m2mMixin) {
  /* === Acl class === */

  /**
   * Acl model
   *
   * @class Acl
   * @classdesc Acl model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.m2mMixin
   * @mixes models.onOffMixin
   * @mixes models.FileUploadMixin
   * @return {models.Acl} Acl entity
   */
  function Acl () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  Acl.prototype = Object.create(Entity.prototype)
  Acl.prototype.constructor = Acl

  /* === Acl instance methods & fields === */

  Object.assign(Acl.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Acl#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      enabled: true,
      aclType: String,
      geoEnabled: true,
      geoAclMode: ACL_MODE_TYPES.BLOCK,
      geoCountries: [String],
      geoOverrideIps: [String],
      ipEnabled: true,
      ipAclMode: ACL_MODE_TYPES.BLOCK,
      ipAddresses: [String],
      vods: [{ id: Number, name: String }],
      tvChannels: [{ id: Number, name: String, channelType: String }],
      radioChannels: [{ id: Number, name: String, channelType: String }],
      tvShows: [{ id: Number, name: String }],
      networks: ['Network'],
      createdTime: String,
      updatedTime: String,
      createdBy: String,
      updatedBy: String
    },

    /**
     * url template
     *
     * @memberof models.Acl#
     * @type {String}
     */
    _urlTemplate: 'api/acls/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.acl#
     * @type {String}
     */
    _publicUrlTemplate: 'geoblocking/{{::aclId}}',
  }, onOffMixin, m2mMixin('networks'))

  /* === Acl static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(Acl, Entity)
  Acl._name = 'Acl'
  Acl.init()

  // permissions
  // Acl.access = {}

  // extra
  // Acl.extra = {}

  return Acl
}
